import { render, staticRenderFns } from "./PostingSupplyDetailForProductionInput.vue?vue&type=template&id=8b08a18c&scoped=true&"
import script from "./PostingSupplyDetailForProductionInput.vue?vue&type=script&lang=js&"
export * from "./PostingSupplyDetailForProductionInput.vue?vue&type=script&lang=js&"
import style0 from "./PostingSupplyDetailForProductionInput.vue?vue&type=style&index=0&id=8b08a18c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b08a18c",
  null
  
)

export default component.exports